import { createContext, useContext, useState } from 'react'
import { supabase } from '../supabase/client';

export const SpecialtiesContext = createContext();

export const useSpecialty = () => {
    const context = useContext(SpecialtiesContext);
    if (!context) {
        throw new Error('useSpecialty debe estar dentro del proveedor SpecialtiesContext')
    }
    return context;
};

export const SpecialtiesContextProvider = ({ children }) => {
    const [specialties, setSpecialties] = useState([])
    const [modal, setModal] = useState(false)

    const getModal = () => {
        setModal(false)
    }

    const getSpecialties = async () => {
        const { error, data } = await supabase
            .from('specialties')
            .select('id, name')
            .eq('status', true)
            .order('name', { ascending: true })
        if (error) throw (error.message)
        setSpecialties(data)
    }

    const getSpecialty = async (id) => {
        const { error, data } = await supabase
            .from('specialties')
            .select()
            .eq('id', id)
            .single()
        if (error) throw (error.message)
        return data
    }

    const createSpecialty = async (formData) => {
        const { error, status, statusText } = await supabase
            .from('specialties')
            .insert(formData)
            .select()
        if (status !== 201) return {
            title: statusText,
            msg: error.message + " Code:[" + error.code + "]",
            icon: 'error',
            code: status
        }
        await getSpecialties()
        setModal(true)
        return {
            title: statusText,
            msg: "Registro creado correctamente",
            icon: 'success',
            code: status
        }
    }

    const updateSpecialty = async (formData, id) => {
        try {
            const { error, status, statusText } = await supabase
                .from('specialties')
                .update(formData)
                .eq('id', id)
                .select()
            if (status !== 200) return {
                title: statusText,
                msg: error.message + " Code:[" + error.code + "]",
                icon: 'error'
            }
            await getSpecialties()
            setModal(true)
            return ({
                title: statusText,
                msg: 'Registro actualizado correctamente',
                icon: 'success'
            })
        } catch (e) {
            console.error(e)
        }
    }


    return (
        <SpecialtiesContext.Provider value={{
            specialties,
            modal,
            getSpecialties,
            getSpecialty,
            createSpecialty,
            updateSpecialty,
            getModal
        }}>
            {children}
        </SpecialtiesContext.Provider>
    )
}